const song3 = [
  [
    "милое дитя, со временем ты увидишь линию",
    "Sweet Child in time you’ll see the line",
  ],
  [
    "линию, которая между добром и злом",
    "The line that’s drawn between the good and the bad",
  ],
  [
    "ты увидишь слепца, стреляющего в мир",
    "See the blind man shooting at the world",
  ],
  ["пули летят собирая дань", "Bullets flying taking toll."],
  [
    "если ты был плохим, Господи, держу пари, ты им был",
    "If you’ve been bad, о Lord, I bet you have",
  ],
  [
    "и тебя не настиг летящий свинец",
    "And you’ve not been hit by the flying lead",
  ],
  [
    "лучше закрой глаза, пригни голову",
    "You’d better close your eyes and bow your head",
  ],
  ["жди рикошет", "And wait for the ricochet."],
];

export default song3;
